import { useQuery } from '@tanstack/react-query';

import { getUserPerson } from '../services/individualBioService';
import { UserPerson } from '../types';

export const useUserDetails = (userPersonUuid?: string | null) => {
  const { data, isLoading, error } = useQuery<UserPerson, Error>({
    queryKey: ['userDetails', userPersonUuid],
    queryFn: () => getUserPerson(userPersonUuid!),
    enabled: !!userPersonUuid,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    userDetails: data || null,
    loading: isLoading,
    error: error?.message || null,
  };
};
